import Divider from '@material-ui/core/Divider';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import React, { Component } from 'react';
import { ActionButton, CancelButton, LinkButton } from '../../../components/ux/Buttons';

import LocationAssigner from '../../../components/locations/LocationAssigner';
import { translate } from '../../../l10n';
import { lodash as _, constants } from '../../../common';

const NO_ACTION = false;

const defaultAssignment = {
   noLocationAssignmentType: constants.locationAssignmentTypes.ALL_LOCATIONS.id,
   all: true,
   specific: [],
   at: [],
   within: [],
   atTaggedAs: null
};

class StaffActionBar extends Component {
   constructor(props) {
      super(props);

      this.state = this.buildFromProps(props);
   }

   buildFromProps(props, currentState = {}) {
      let assignment = props.assignment ? props.assignment : _.cloneDeep(defaultAssignment);

      var s = {
         ...{
            action: NO_ACTION,
            assignment
         },
         ...currentState
      };

      return s;
   }

   UNSAFE_componentWillReceiveProps(nextProps) {
      const newState = this.buildFromProps(nextProps, { action: this.state.action });
      //const newState = this.buildFromProps(nextProps, {});

      if (newState.assignment !== this.state.assignment) {
         this.setState(newState);
      }
   }

   _onTabChange = (event, value) => {
      this.setState({ action: value });
   };

   isAssigning = () => {
      const { selectedStaffMemberNos } = this.props;
      const { action } = this.state;
      return action == 1 && selectedStaffMemberNos.length > 0;
   };

   isDeleting = () => {
      const { selectedStaffMemberNos } = this.props;
      const { action } = this.state;
      return action == 2 && selectedStaffMemberNos.length > 0;
   };

   _onCancelActionClick = () => {
      this.setState({ action: NO_ACTION });
   };

   _onAssignClick = () => {
      const { assignment } = this.state;
      const { selectedStaffMemberNos, onAssignStaffLocations } = this.props;

      let nosStaff = _.flatten(
         _.map(selectedStaffMemberNos, (m) => {
            return m.noUser;
         })
      );

      const o = {
         nosStaff,
         ...assignment
      };

      onAssignStaffLocations(o);

      this.setState({ action: NO_ACTION });
   };

   _onDeleteClick = () => {
      const { selectedStaffMemberNos, onRemoveStaffMembers } = this.props;

      let nosStaff = _.flatten(
         _.map(selectedStaffMemberNos, (m) => {
            return m.noUser;
         })
      );

      const o = {
         nosStaff
      };

      this.setState({ action: NO_ACTION });

      onRemoveStaffMembers(o);
   };

   _onAssignLocationsClicked = () => {
      this.setState({ action: 1, assignment: _.cloneDeep(defaultAssignment) });
   };

   _onDeleteStaffMembersClicked = () => {
      this.setState({ action: 2 });
   };

   _onAssignmentChanged = ({ assignment }) => {
      this.setState({ assignment });
   };

   render() {
      const { selectedStaffMemberNos, availableLocations, availableTags } = this.props;
      const { assignment } = this.state;

      const disableTabs = selectedStaffMemberNos.length == 0;
      const canAssign = assignment.noLocationAssignmentType !== constants.locationAssignmentTypes.UNASSIGNED.id;

      return (
         <div className={'StaffActionBar'}>
            <div className='actions'>
               <LinkButton
                  caption='staff.actionbar.link.assign'
                  onClick={this._onAssignLocationsClicked}
                  disabled={disableTabs}
                  color='primary'
               />
               <span>·</span>
               <LinkButton
                  caption='staff.actionbar.link.delete'
                  onClick={this._onDeleteStaffMembersClicked}
                  disabled={disableTabs}
                  color='primary'
               />
            </div>

            {this.isAssigning() && (
               <Grow in={this.isAssigning()}>
                  <Paper className={'action-panel'} elevation={1}>
                     <Typography variant='h6'>{translate('staff.actionbar.header.assign')}</Typography>
                     <div style={{ display: 'flex', flexFlow: 'row nowrap', justifyContent: 'flex-start', alignItems: 'center' }}>
                        <LocationAssigner
                           availableLocations={availableLocations}
                           availableTags={availableTags}
                           readOnly={false}
                           onChange={this._onAssignmentChanged}
                           assignment={assignment}
                        />
                     </div>
                     <Divider />
                     <div style={{ paddingTop: 8 }}>
                        <ActionButton disabled={!canAssign} caption='staff.actionbar.button.assign' onClick={this._onAssignClick} />
                        <CancelButton showOr={true} onClick={this._onCancelActionClick} />
                     </div>
                  </Paper>
               </Grow>
            )}

            {this.isDeleting() && (
               <Grow in={this.isDeleting()}>
                  <Paper className={'action-panel'} elevation={3}>
                     <Typography variant='h6'>{translate('staff.actionbar.header.confirmDelete')}</Typography>
                     <Typography variant='body1'>{translate('staff.actionbar.text.explainDelete1')}</Typography>
                     <Typography variant='body1'>{translate('staff.actionbar.text.explainDelete2')}</Typography>
                     <Divider />
                     <div style={{ paddingTop: 8 }}>
                        <ActionButton caption='staff.actionbar.button.confirmDelete' className='delete-btn' onClick={this._onDeleteClick} />
                        <CancelButton showOr={true} onClick={this._onCancelActionClick} />
                     </div>
                  </Paper>
               </Grow>
            )}
         </div>
      );
   }
}

StaffActionBar.defaultProps = {
   assignment: null,
   availableLocations: [],
   availableTags: [],
   selectedStaffMemberNos: [],
   onRemoveStaffMembers: () => {},
   onAssignStaffLocations: () => {}
};

StaffActionBar.propTypes = {
   //onSet: PropTypes.func.isRequired,
};

export default StaffActionBar;
